import { UpsellingKitProductBanner } from 'modules/upselling_kit/types'

import { UpsellGuard } from '../UpsellGuard'
import ProductBannerContent from './_Content'

const ProductBanner = ({
  title,
  subtitle,
  mediaUrl,
  primaryAction,
  secondaryAction,
  onClose,
  learnMoreNavigate,
  fallbackComponent,
  loadingComponent,
  ...upsellProps
}: UpsellingKitProductBanner) => {
  return (
    <UpsellGuard
      {...upsellProps}
      fallbackComponent={fallbackComponent || null}
      loadingComponent={loadingComponent || null}
    >
      <ProductBannerContent
        {...upsellProps}
        title={title}
        subtitle={subtitle}
        mediaUrl={mediaUrl}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
        onClose={onClose}
        learnMoreNavigate={learnMoreNavigate}
      />
    </UpsellGuard>
  )
}

export { ProductBanner }
